import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { IOption } from "ng-select";
import { NgxSpinnerService } from "ngx-spinner";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";

import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { BsModalService } from "ngx-bootstrap/modal";

import {
  DropzoneComponent,
  DropzoneConfigInterface,
  DropzoneDirective,
} from "ngx-dropzone-wrapper";

import { HelperService } from "../../services/helper.service";
import { TosterMessageService } from "../../services/toster-message.service";
import { SupplierEvaluationService } from "../../services/supplier-evaluation.service";
import { AddContactModalComponent } from "../add-contact-modal/add-contact-modal.component";
import { EditContactModalComponent } from "../edit-contact-modal/edit-contact-modal.component";
import { AddProductRangeModalComponent } from "../add-product-range-modal/add-product-range-modal.component";
import { EditProductRangeModalComponent } from "../edit-product-range-modal/edit-product-range-modal.component";
import { AddMajorCustomerModalComponent } from "../add-major-customer-modal/add-major-customer-modal.component";
import { EditMajorCustomerModalComponent } from "../edit-major-customer-modal/edit-major-customer-modal.component";
import { AddCertificationDetailsModalComponent } from "../add-certification-details-modal/add-certification-details-modal.component";
import { EditCertificationDetailsModalComponent } from "../edit-certification-details-modal/edit-certification-details-modal.component";
import { NgForm } from "@angular/forms";
import { CorrectiveActionModalComponent } from "app/corrective-action-modal/corrective-action-modal.component";
//import { any } from "@amcharts/amcharts4/.internal/core/utils/Array";

@Component({
  selector: "app-supplier-evaluation-form",
  templateUrl: "./supplier-evaluation-form.component.html",
  styleUrls: ["./supplier-evaluation-form.component.scss"],
  providers: [HelperService, SupplierEvaluationService, TosterMessageService],
})
export class SupplierEvaluationFormComponent implements OnInit {
  @ViewChild(DropzoneComponent) public componentRef?: DropzoneComponent;
  bsConfig: Partial<BsDatepickerConfig>;
  colorTheme = "theme-blue";
  public bsModalRef: BsModalRef;
  files: File[] = [];
  isExpired: false;
  public supplier_evaluation: any = {
    companyID: null,
    contact_details: [],
    product_range: [],
    major_customer_list: [],
    certification_details: [],
    attachments: [],
    checkList: [],
    questions: null,
  };
  public countryArr: Array<IOption> = [];
  public categoryArr: Array<IOption> = [];
  public certificationArr: Array<IOption> = [];
  isCollapsed: boolean = true;
  isProductRangeCollapsed: boolean = true;
  isMajorCustomerCollapsed: boolean = true;
  isCertificationDetailsCollapsed: boolean = true;
  isQuestionCollapsed: boolean = true;
  isInitialAssesmentCollapsed: boolean = true;
  isAttachmentsCollapsed: boolean = true;
  index: any;
  submitted: boolean = false;
  checklistCategoryArr: any;
  checklistGuidelines: any;
  checklistColumnsArr: any;
  checklistCriteriaScoreArr: any;
  checklistCriteriaArr: any;
  public checklistSelectedAutoID: number = 1;
  correctiveActionDetail: {};
  bsModalRefCorrectiveAction: BsModalRef;
  id: any;
  documentSystemID: any = 25;
  bsValue = new Date();
  public priorityArr: Array<IOption> = [];
  public disabledClosedRadio: any;
  public disabled: boolean = false;
  questions: any;

  constructor(
    private helperService: HelperService,
    private SupplierEvaluationService: SupplierEvaluationService,
    private tosterMessageService: TosterMessageService,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService,
    private route: ActivatedRoute
  ) {
    this.bsConfig = Object.assign(
      {},
      {
        containerClass: this.colorTheme,
        dateInputFormat: "DD/MM/YYYY",
      }
    );
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.supplier_evaluation.companyID = params.companyID;
      this.supplier_evaluation.hash_code = params.uuid;
    });

    this.getSupplierEvaluationFormData();

    this.modalService.onHide.subscribe((reason: string, event) => {
      if (reason) {
        if (reason === "modalSaved") {
          if (
            this.bsModalRef &&
            this.bsModalRef.content &&
            this.bsModalRef.content.contact_detail
          ) {
            this.supplier_evaluation.contact_details.push(
              this.bsModalRef.content.contact_detail
            );
          }
          if (
            this.bsModalRef &&
            this.bsModalRef.content &&
            this.bsModalRef.content.edit_contact_detail
          ) {
            this.supplier_evaluation.contact_details[this.index] =
              this.bsModalRef.content.edit_contact_detail;
          }
          if (
            this.bsModalRef &&
            this.bsModalRef.content &&
            this.bsModalRef.content.product_range
          ) {
            this.supplier_evaluation.product_range.push(
              this.bsModalRef.content.product_range
            );
          }
          if (
            this.bsModalRef &&
            this.bsModalRef.content &&
            this.bsModalRef.content.edit_product_range
          ) {
            this.supplier_evaluation.product_range[this.index] =
              this.bsModalRef.content.edit_product_range;
          }
          if (
            this.bsModalRef &&
            this.bsModalRef.content &&
            this.bsModalRef.content.major_customer
          ) {
            this.supplier_evaluation.major_customer_list.push(
              this.bsModalRef.content.major_customer
            );
          }
          if (
            this.bsModalRef &&
            this.bsModalRef.content &&
            this.bsModalRef.content.edit_major_customer
          ) {
            this.supplier_evaluation.major_customer_list[this.index] =
              this.bsModalRef.content.edit_major_customer;

            this.supplier_evaluation.major_customer_list[this.index].countryID =
              Array.isArray(
                this.bsModalRef.content.edit_major_customer.countryID
              )
                ? this.bsModalRef.content.edit_major_customer.countryID[0]
                : this.bsModalRef.content.edit_major_customer.countryID;
          }
          if (
            this.bsModalRef &&
            this.bsModalRef.content &&
            this.bsModalRef.content.certification_detail
          ) {
            this.supplier_evaluation.certification_details.push(
              this.bsModalRef.content.certification_detail
            );
          }
          if (
            this.bsModalRef &&
            this.bsModalRef.content &&
            this.bsModalRef.content.edit_certification_detail
          ) {
            this.supplier_evaluation.certification_details[this.index] =
              this.bsModalRef.content.edit_certification_detail;
            this.supplier_evaluation.certification_details[
              this.index
            ].certification_type_id = Array.isArray(
              this.bsModalRef.content.edit_certification_detail
                .certification_type_id
            )
              ? this.bsModalRef.content.edit_certification_detail
                  .certification_type_id[0]
              : this.bsModalRef.content.edit_certification_detail
                  .certification_type_id;
          }
        }
      }
    });
  }

  getSupplierEvaluationFormData() {
    const that = this;
    that.spinner.show();
    that.SupplierEvaluationService.getSupplierEvaluationFormData()
      .get({
        companyID: this.supplier_evaluation.companyID,
        hashCode: this.supplier_evaluation.hash_code,
      })
      .subscribe(
        (data) => {
          let z = 0;
          var resp = data.data.data;
          that.isExpired = resp.expired;
          that.supplier_evaluation.questions = resp.questions;
          that.countryArr = that.helperService.setSelect2DropDownOptions(
            resp.countries,
            "countryID",
            "countryName"
          );
          that.categoryArr = that.helperService.setSelect2DropDownOptions(
            resp.categories,
            "id",
            "description"
          );
          that.certificationArr = that.helperService.setSelect2DropDownOptions(
            resp.certification_types,
            "id",
            "description"
          );

          that.checklistCategoryArr = resp.category;
          that.checklistColumnsArr = resp.headerColumns;
          for (var index = 0; index < resp.headerColumns.length; index++) {
            if (
              resp.headerColumns[index]["columnTypeID"] == 2 ||
              resp.headerColumns[index]["columnTypeID"] == 3
            ) {
              resp.headerColumns[index]["text"] = z + 1;
              z++;
            }
          }
          that.checklistColumnsArr = resp.headerColumns;
          for (var index = 0; index < resp.criteria.length; index++) {
            if (
              resp.criteria[index]["criteriaDropdown"] != null &&
              resp.criteria[index]["criteriaDropdown"] != ""
            ) {
              resp.criteria[index]["criteriaDropdown"] = [
                resp.criteria[index]["criteriaDropdown"],
              ];
            }
          }
          that.checklistCriteriaArr = resp.criteria;
          that.spinner.hide();
        },
        (error) => {
          that.spinner.hide();
        }
      );
  }

  processCountryDropdown(value) {}

  onSelect(event) {
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  addContactDetails() {
    this.bsModalRef = this.modalService.show(AddContactModalComponent, {
      class: "modal-md",
      backdrop: "static",
    });
  }

  deleteContact(index) {
    this.supplier_evaluation.contact_details.splice(index, 1);
  }

  editContact(contact, index) {
    let contact_detail = {
      contact_name: contact.contact_name,
      position: contact.position,
      phone: contact.phone,
      email: contact.email,
    };
    this.index = index;
    this.bsModalRef = this.modalService.show(EditContactModalComponent, {
      class: "modal-md",
      backdrop: "static",
    });
    this.bsModalRef.content.is_edit = true;
    this.bsModalRef.content.edit_contact_detail = contact_detail;
  }

  addProductRange() {
    this.bsModalRef = this.modalService.show(AddProductRangeModalComponent, {
      class: "modal-md",
      backdrop: "static",
    });
  }

  editProductRange(product, index) {
    let product_range = {
      description: product.description,
      unit: product.unit,
    };
    this.index = index;
    this.bsModalRef = this.modalService.show(EditProductRangeModalComponent, {
      class: "modal-md",
      backdrop: "static",
    });
    this.bsModalRef.content.edit_product_range = product_range;
  }

  deleteProductRange(index) {
    this.supplier_evaluation.product_range.splice(index, 1);
  }

  addMajorCustomer() {
    this.bsModalRef = this.modalService.show(AddMajorCustomerModalComponent, {
      class: "modal-md",
      backdrop: "static",
    });
    this.bsModalRef.content.countryArr = this.countryArr;
  }

  editMajorCustomer(customer, index) {
    let major_customer = {
      customer_name: customer.customer_name,
      countryID: [customer.countryID],
      country: customer.country,
    };
    this.index = index;
    this.bsModalRef = this.modalService.show(EditMajorCustomerModalComponent, {
      class: "modal-md",
      backdrop: "static",
    });
    this.bsModalRef.content.edit_major_customer = major_customer;
    this.bsModalRef.content.countryArr = this.countryArr;
  }

  deleteMajorCustomer(index) {
    this.supplier_evaluation.major_customer_list.splice(index, 1);
  }

  addCertificationDetails() {
    this.bsModalRef = this.modalService.show(
      AddCertificationDetailsModalComponent,
      {
        class: "modal-md",
        backdrop: "static",
      }
    );
    this.bsModalRef.content.certificationArr = this.certificationArr;
  }

  editCertificationDetails(certification, index) {
    let certification_detail = {
      certification_type: certification.certification_type,
      certification_type_id: [certification.certification_type_id],
      certification_no: certification.certification_no,
      date_certified: certification.date_certified,
      expiration_date: certification.expiration_date,
      attachment: certification.attachment,
    };
    this.index = index;
    this.bsModalRef = this.modalService.show(
      EditCertificationDetailsModalComponent,
      {
        class: "modal-md",
        backdrop: "static",
      }
    );
    this.bsModalRef.content.certificationArr = this.certificationArr;
    this.bsModalRef.content.edit_certification_detail = certification_detail;
    this.bsModalRef.content.files = certification_detail.attachment;
  }

  deleteCertificationDetails(index) {
    this.supplier_evaluation.certification_details.splice(index, 1);
  }

  setSelectedOption(question, answer) {
    for (
      let j = 0;
      j < this.supplier_evaluation.questions[question].options.length;
      j++
    ) {
      if (j == answer) {
        this.supplier_evaluation.questions[question].options[
          j
        ].is_correct_default = true;
      } else {
        this.supplier_evaluation.questions[question].options[
          j
        ].is_correct_default = false;
      }
    }
  }

  formCreate(f: NgForm) {
    const that = this;
    let reader = 0;
    that.supplier_evaluation.attachments = [];
    this.submitted = true;
    this.supplier_evaluation.checklist = that.checklistCriteriaArr;
    for (let i = 0; i < this.files.length; i++) {
      this.helperService.readFile(this.files[i]).then((fileContents) => {
        reader = reader + 1;
        // Put this string in a request body to upload it to an API.
        let tem = this.files[i];
        let parts = tem.name.split(".");
        let data = {
          name: tem.name,
          size: tem.size,
          type: tem.type,
          extension: parts[parts.length - 1],
          file: fileContents,
        };
        that.supplier_evaluation.attachments.push(data);
        if (reader == this.files.length) {
          this.SupplierEvaluationService.createSupplierEvaluationForm()
            .post(this.supplier_evaluation)
            .subscribe(
              (resp) => {
                f.resetForm();
                this.submitted = false;
                this.supplier_evaluation.attachments = [];
                (this.supplier_evaluation.contact_details = []),
                  (this.supplier_evaluation.product_range = []),
                  (this.supplier_evaluation.major_customer_list = []),
                  (this.supplier_evaluation.certification_details = []),
                  (this.files = []),
                  this.tosterMessageService.showSuccess(
                    "Success",
                    "Successfully submitted. You will be notified once we review your application."
                  );
                this.helperService.go("supplier-evaluation-success");
              },
              (error) => {
                this.submitted = false;
                this.tosterMessageService.showWarning(
                  "Warning",
                  error.data.message
                );
              }
            );
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/supplier-evaluation-form/supplier-evaluation-form/supplier-evaluation-form.component.ts